import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { FeatureFlags } from '@/types/FeatureFlags';
import { getIsWhiteLabel } from './whiteLabel';
import { routes as getRoutes } from '@/routes';
import { Location, matchRoutes } from 'react-router-dom';
import { Variants } from '@amplitude/experiment-js-client';

export const loadPageData = createAsyncThunk<
    Promise<unknown>[],
    {
        amplitudeExperimentFlags: Variants;
        featureFlags: FeatureFlags;
        location: Location;
    }
>(
    'la/ui/appState/loadPageData',
    async ({ amplitudeExperimentFlags, featureFlags, location }, { dispatch, getState }) => {
        const state = getState();

        // Need to know if the app is working as whitelabel
        const isWhiteLabel = getIsWhiteLabel(state);

        // Get application routes
        const routes = getRoutes({
            amplitudeExperimentFlags,
            featureFlags,
            isWhiteLabel,
        });

        // Get all the currently active matching branch routes
        const branches = matchRoutes(routes, location.pathname);

        // Make an array of promises for the page data
        const promises = branches.map((branch) => {
            const { params, route } = branch;
            if (route.loadData) {
                return route.loadData({
                    amplitudeExperimentFlags,
                    featureFlags,
                    location,
                    match: { params: params },
                    routerState: {},
                    store: {
                        dispatch,
                        getState,
                    },
                });
            }

            return Promise.resolve();
        });

        return Promise.all(promises);
    }
);
